import { TEST_LIST, QUESTION, ANSRESULT, TEST_RESULT, FEEDBACKSTATUS, FEEDBACKDATA, FEEDBACKSALESLIST } from '../constant/ActionTypes';

export const dashRecuder = (state, action) => {
    switch (action.type) {
        case TEST_LIST:
            return {
                ...state,
                testList: action.payload
            };
        case FEEDBACKSTATUS:
            return {
                ...state,
                feedbackstatus: action.payload
            };
        case FEEDBACKDATA:
            return {
                ...state,
                feedbackdata: action.payload
            };
        case QUESTION:
            return {
                ...state,
                question: action.payload
            };
        case ANSRESULT:
            return {
                ...state,
                ansresult: action.payload
            };
        case TEST_RESULT:
            return {
                ...state,
                testResult: action.payload
            };
        case FEEDBACKSALESLIST:
            return {
                ...state,
                feedbackSalesList: action.payload
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/dashRecuder.js